import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import NotFound from '../views/404.vue'
// // 会员管理
import MemberList from '../views/ShopManagement/MemberList.vue'
import BasicinfoManager from '../views/ShopManagement/BasicinfoManager.vue'



import ShopControl from '../views/ShopManagement/ShopControl.vue'
import ShopInfo from '../views/ShopManagement/ShopInfo.vue'
import ShopUser from '../views/ShopManagement/ShopUser.vue'
import EvaluateShop from '../views/ShopManagement/EvaluateShop.vue'

// import Page6 from './views/nav3/Page6.vue'
// import echarts from './views/charts/echarts.vue'
import ShopList from '../views/ShopManagement/ShopList.vue'
// import Authority from './views/Authority.vue'
import ShopStatistics from '../views/ShopManagement/ShopStatistics.vue'
import SummaryTabsView  from '../views/ShopManagement/SummaryTabsView.vue'
import ShopIntroduction from '../views/ShopManagement/ShopIntroduction.vue'
import PaymentInformation from '../views/ShopManagement/PaymentInformation.vue'
import CoachlogReport from '../views/ShopManagement/CoachlogReport.vue'
import CoachlogReportDay from '../views/ShopManagement/CoachlogReportDay.vue'
import Dimension from '../views/BasicSetting/Dimension.vue'
import CoachlogReportTavsView from '../views/ShopManagement/CoachlogReportTavsView.vue'



import WeChatOfficialAccount from '../views/WeiXin/WeChatOfficialAccount.vue'
import Certificate from '../views/Archives/Certificate.vue'
import StudentCertificate from '../views/Archives/StudentCertificate.vue'
import Competition from '../views/Competition/Competition.vue'
import CompetitionType from '../views/Competition/CompetitionType.vue'
import CompetitionPosture from '../views/Competition/CompetitionPosture.vue'
import EvaluateDimension from '../views/Evaluate/EvaluateDimension.vue'

import TeamList from '../views/Competition/TeamList.vue'

import SurplusFrequencyCard from '../views/DetachView/Admin/Surplus/FrequencyCard.vue'
import SurplusMonthCard from '../views/DetachView/Admin/Surplus/MonthCard.vue'
import SurplusOwnerCard from '../views/DetachView/Admin/Surplus/OwnerCard.vue'
import SurplusRechargeableCard from '../views/DetachView/Admin/Surplus/RechargeableCard.vue'
import SurplusTrainingCard from '../views/DetachView/Admin/Surplus/TrainingCard.vue'
import SurplusYearCard from '../views/DetachView/Admin/Surplus/YearCard.vue'

import SwimmingData from '../views/SwimmingData/Admin/SwimmingData.vue'
import WaterQualityData from '../views/WaterQuality/Admin/WaterQualityData.vue'
import Water from '../views/WaterQuality/Admin/Water.vue'
import WattMeter from '../views/WaterQuality/Admin/WattMeter.vue'

const routeadmin = 
     [    
    {
      path:'/',
      component: Home,
      hidden: true
    },
       
        {
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '门店管理',
            iconCls: 'el-icon-message',
            children: [           
                // 租主使用
                { path:'/ShopList',  component: ShopList, name:'门店列表'},
                // 门店使用
                { path: '/ShopControl', component: ShopControl, name: '门店总控' },
                // 租主使用
                { path: '/ShopUser', component: ShopUser, name: '门店账号' },
                { path: '/ShopStatistics', component: ShopStatistics, name: '短信汇总' },
                { path: '/SummaryTabsView', component: SummaryTabsView, name: '统计图表' },
                { path: '/ShopIntroduction', component: ShopIntroduction, name: '门店简介' },     
                { path: '/PaymentInformation', component: PaymentInformation, name: '支付信息' },     
                { path: '/BasicinfoManager', component: BasicinfoManager, name: '系统会员' },                                   
            ]
        },
        {
            // 门店使用
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '业务量查询',
            iconCls: 'fa fa-bar-chart',
            children: [
                { path: '/SurplusFrequencyCard', component: SurplusFrequencyCard, name: '次卡业务' }, 
                { path: '/SurplusMonthCard', component: SurplusMonthCard, name: '月卡业务' },
                { path: '/SurplusYearCard', component: SurplusYearCard, name: '年卡业务' },                                    
                { path: '/SurplusOwnerCard', component: SurplusOwnerCard, name: '业主卡业务' },                  
                { path: '/SurplusRechargeableCard', component: SurplusRechargeableCard, name: '充值卡业务' },                  
                { path: '/SurplusTrainingCard', component: SurplusTrainingCard, name: '培训卡业务' }                                
            ]
        },        
        {
            // 门店使用
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '教练管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                // { path: '/ChangeCoachLog', component: ChangeCoachLog, name: '更换教练' }, 
                // { path: '/CoachlogReport', component: CoachlogReport, name: '教练报表' },
                // { path: '/CoachlogReportDay', component: CoachlogReportDay, name: '教练日报表' },
                { path: '/CoachlogReportTavsView', component: CoachlogReportTavsView, name: '教练报表' }

  
                    
            ]
        },
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '评价管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                // { path: '/ChangeCoachLog', component: ChangeCoachLog, name: '更换教练' }, 
                { path: '/Dimension', component: Dimension, name: '考察维度' },
                // { path: '/DimensionShop', component: DimensionShop, name: '门店考察维度' },
                { path: '/EvaluateDimension', component: EvaluateDimension, name: '评价报表' },
                //{ path: '/EvaluateShop', component: EvaluateShop, name: '场馆评价记录' },                     
            ]
        },

        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '微信管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                // { path: '/ChangeCoachLog', component: ChangeCoachLog, name: '更换教练' }, 
                { path: '/WeChatOfficialAccount', component: WeChatOfficialAccount, name: '公众号管理' },
                // { path: '/TrainingReport', component: TrainingReport, name: '培训报表' }

                    
            ]
        },   
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '档案管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                // { path: '/ChangeCoachLog', component: ChangeCoachLog, name: '更换教练' }, 
                { path: '/Certificate', component: Certificate, name: '证书模板' },
                { path: '/StudentCertificate', component: StudentCertificate, name: '学员证书' }                   
            ]
        }, 
          
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '赛事管理',
            iconCls: 'fa fa-bar-chart',
            children: [
                // { path: '/ResetLog', component: ResetLog, name: '重置日志' },
                { path: '/CompetitionType', component: CompetitionType, name: '赛事分类' }, 
                { path: '/CompetitionPosture', component: CompetitionPosture, name: '赛事泳姿' }, 
                { path: '/Competition', component: Competition, name: '赛事组织' },
                { path: '/TeamList', component: TeamList, name: '队伍管理' },                                     
            ]
        },    
          
        {
            
            path: '/',
            component: (resolve) => require(['../views/Home.vue'], resolve),
            name: '场馆数据',
            iconCls: 'fa fa-bar-chart',
            children: [
                { path: '/SwimmingData', component: SwimmingData, name: '运动数据' },  
                { path: '/WaterQualityData', component: WaterQualityData, name: '水质数据' },  
                { path: '/Water', component: Water, name: '水表数据' },  
                { path: '/WattMeter', component: WattMeter, name: '电表数据' },                                       
            ]
        },               
        
        
        {
            path: '/404',
            component: NotFound,
            name: '',
            hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ];
 
    

export default routeadmin;


// WEBPACK FOOTER //
// ./src/userroutes/landlord.js